/* eslint-disable import/prefer-default-export */
export const setEvent = (state, event) => {
  state.event = event;
};
export const setHost = (state, host) => {
  state.host = host;
};
export const setSavedGuests = (state, savedGuests) => {
  state.savedGuests = savedGuests;
};
export const setEventGuests = (state, eventGuests) => {
  state.eventGuests = eventGuests;
};
